import React from "react";
//#region types
import { ChartEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import useChartContext from "./context/useContext";
import ToggleButtonGroup from "../buttons/toggleButtonGroup";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ChartToggle: React.FC = (props) => {
  const chartContext = useChartContext();

  const onIndividualButtonClick = () => {
    chartContext?.setChartType(ChartEnums.DisplayType.Periodically);
  };

  const onAccumulatedButtonClick = () => {
    chartContext?.setChartType(ChartEnums.DisplayType.Accumulated);
  };

  return (
    <Grid item className={cssExports.toggleContainer}>
      <ToggleButtonGroup
        buttons={[
          {
            children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Periodically),
            onClick: onIndividualButtonClick,
          },
          {
            children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Accumulated),
            onClick: onAccumulatedButtonClick,
          },
        ]}
      />
    </Grid>
  );
};

export default ChartToggle;
